import React from "react";
import { Card, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";

type HeaderCardProps = {
  title: string | React.JSX.Element;
  subtitle?: string | React.JSX.Element;
  trailing?: React.JSX.Element;
  testID?: string;
};

export function HeaderCard({
  title,
  subtitle,
  trailing,
  testID = "header-card",
}: HeaderCardProps) {
  return (
    <Card className={styles.wrapper} testID={testID}>
      <div className={styles.title}>
        <Text style="global/heading-large">{title}</Text>
        <Text style="global/body-secondary" color="text-weak">
          {subtitle}
        </Text>
      </div>

      {trailing}
    </Card>
  );
}

const styles = {
  wrapper: css({
    borderRadius: "var(--border-radius-4)",
    display: "flex",
    padding: "var(--space-4)",
    justifyContent: "space-between",
    alignItems: "center",
  }),
  title: css({
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
  }),
};
